const state = {
	env: '', // 当前环境，wx:微信公众号 ali: 支付宝生活号
	source: '', // 1:wx 0:支付宝
	noEnv: true // 是否设初始化过环境的标志, 默认没有初识化过
}

function getSourceByEnv(env){
	let source
	switch(env){
		case 'wx':
			source = 1
			break
		case 'ali':
			source= 0
			break
		default:
		  source = -1
	}
	return source
}

const mutations = {
	/**
	 * 
	 * @param {*} state 
	 * @param {String} type 
	 */
	initEnv(state, type){
		state.env = type
		state.source = getSourceByEnv(type)
		state.noEnv = false
	}
}

export default {
	state,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Env.js